import { cn } from "../../lib/utils.mjs";
import { jsx } from "react/jsx-runtime";
//#region src/components/ui/kbd.tsx
function Kbd({ className, ...props }) {
	return /* @__PURE__ */ jsx("kbd", {
		"data-slot": "kbd",
		className: cn("pointer-events-none inline-flex h-5 w-fit min-w-5 select-none items-center justify-center gap-1 rounded-xxxs border border-border bg-muted px-1 font-sans text-xs font-medium text-muted-foreground", className),
		...props
	});
}
function KbdGroup({ className, ...props }) {
	return /* @__PURE__ */ jsx("kbd", {
		"data-slot": "kbd-group",
		className: cn("inline-flex items-center gap-1", className),
		...props
	});
}
//#endregion
export { Kbd, KbdGroup };
